import Language from '@/types/env/Language';

export const LANGUAGE_EN: Language = {
  id: 'en',
  title: 'English',
};

const LANGUAGES: Language[] = [LANGUAGE_EN];

export default LANGUAGES;
